import useFactoryLevelBuilder from 'frontend/presentation/factory-levels/domain/useFactoryLevelBuilder'
import { store as baseStore } from 'frontend/store/store'

type LandingFetcherStore = {
  dispatch: (action:
    'fetchPatterns' |
    'fetchPerimeters' |
    'fetchProductionHierarchy' |
    'fetchProductionFormats'
  ) => Promise<void>
}
const store = baseStore as unknown as LandingFetcherStore

type ApplicationFetch = { promise: Promise<void> | null }
const applicationFetch: ApplicationFetch = { promise: null }

const useApplicationFirstFetch = () => {
  const { createFactoryLevelStructure } = useFactoryLevelBuilder()

  const fetchApplicationData = (): Promise<void> => {
    if (applicationFetch.promise !== null) {
      return applicationFetch.promise
    }
    applicationFetch.promise = Promise.all([
      store.dispatch('fetchPatterns'),
      store.dispatch('fetchPerimeters'),
      // These fetches should be removed in future refactors.
      // Do not add more.
      store.dispatch('fetchProductionFormats'),
      store.dispatch('fetchProductionHierarchy'),
    ]).then(() => {
      createFactoryLevelStructure()
    }).catch((error) => {
      applicationFetch.promise = null
      throw error
    })
    return applicationFetch.promise
  }

  return { fetchApplicationData }
}

export default useApplicationFirstFetch
